import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectDataCustomer,
  fetchCustomer,
  createRtv,
  setRtv,
} from "./withrtvSlice";
import {
  sizePerPageList,
  showDialog,
  useForceUpdate,
  showSuccessDialog,
  showErrorDialog,
  formatDatePost,
} from "../../../utility";
import LoadingFetchData from "../../../utility/LoadingFetchData";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { selectUser } from "../../../modules/Auth/_redux/authRedux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import DatePicker from "react-datepicker";

export const WithRtvCreate = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const history = useHistory();
  const dataCustomer = useSelector(selectDataCustomer);

  const user = useSelector(selectUser);
  const plants = user.plants.map((e) => {
    return e.plantCode;
  });

  const [rtvNumber, setRtvNumber] = useState("");
  const [rtvDate, setRtvDate] = useState("");
  const [rtvReceivingDate, setRtvReceivingDate] = useState("");
  const [remarksRtv, setRemarkRtv] = useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      // Reset on first load
      await dispatch(resetData());
    }

    fetchMyAPI();
  }, [dispatch]);

  // fuction date

  const date1 = new Date(formatDatePost(rtvDate));
  const date2 = new Date(formatDatePost(rtvReceivingDate));
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Modal customer
  const [show, setShow] = useState(false);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [selectCustomer, setSelectCustomer] = useState([]);

  const handleClose = () => {
    setCustomerCode("");
    setCustomerName("");
    setShow(false);
    setTableData([]);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [overlayStateCustomer, setOverlayStateCustomer] = useState(false);
  const [showResultsCustomer, setShowResultsCustomer] = useState(false);

  const [tableData, setTableData] = useState(dataCustomer);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataCustomer.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        // blockRemark: checkValue(item),
      };
    });
    setTableData(initData);
  }, [dataCustomer, pageSize, pageNo]);

  const handleSearchCustomer = async () => {
    setOverlayStateCustomer(true);
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      plant: plants.toString(),
      pageNo: pageNo,
      pageSize: pageSize,
    };
    await dispatch(fetchCustomer(params));
    setOverlayStateCustomer(false);
    setShowResultsCustomer(true);
  };

  const handleTableChangeCustomer = async (type, { page, sizePerPage }) => {
    setOverlayStateCustomer(true);

    const params = {
      customerCode: customerCode,
      customerName: customerName,
      plant: plants.toString(),
      pageNo: page,
      pageSize: sizePerPage,
    };
    await dispatch(fetchCustomer(params));
    setOverlayStateCustomer(false);
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  var rowEventsCustomer = {
    onClick: (e, row, rowIndex, cell) => {
      if (row.customerBlocked === true) {
        showDialog(row.blockRemark);
      } else {
        setSelectCustomer(row);
        setCustomerCode(row);
        setCustomerCode("");
        setCustomerName("");
        setShow(false);
        setTableData([]);
        setShow(false);
      }
    },
  };

  // //checker rowRemark
  // const checkValue = (value) => {
  //   let blockRemark = "";
  //   if (value.blockStatus === 2) {
  //     blockRemark = "Customer Block";
  //   } else if (value.orderBlock === 2) {
  //     blockRemark = "Customer Block";
  //   } else if (value.deletionFlag === "X") {
  //     blockRemark = "Customer Deletion Flag";
  //   } else {
  //     blockRemark = "";
  //   }
  //   return blockRemark;
  // };
  // //

  // end fucntion modal

  const handleSave = () => {
    // Validation
    if (rtvNumber === "") {
      return showErrorDialog("Please Insert RTV Number First!");
    }
    if (rtvDate === "" || rtvDate === null) {
      return showErrorDialog("Please RTV Date First!");
    }
    if (rtvReceivingDate === "" || rtvReceivingDate === null) {
      return showErrorDialog("Please RTV Receiving Date First!");
    }
    if (selectCustomer.customerCode === undefined) {
      return showErrorDialog("Please Customer First!");
    }
    if (selectCustomer.customerCode === "") {
      return showErrorDialog("Please Customer First!");
    }

    const params = {
      rtvNo: rtvNumber,
      rtvDate: formatDatePost(rtvDate),
      rtvReceivingDate: formatDatePost(rtvReceivingDate),
      draft: true,
      remarksRtv: remarksRtv,
      customerCode: selectCustomer.customerCode.toString(),
      customerName: selectCustomer.customerName,
      distributionChannel: selectCustomer.distChannel.toString(),
      salesDivision: selectCustomer.salesDivision,
      plantCode: selectCustomer.plantCode,
      plantName: selectCustomer.plantName,
      taxToNPWP: selectCustomer.TaxToNPWP.toString(),
      returnType: "MTKA",
    };
    callApi(params);
    // history.push("/new-return/with-rtv/list");
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createRtv(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your return number : <strong>${response.payload.data.data.retNumber}</strong>`
        );
        if (action.isConfirmed) dispatch(setRtv(response.payload.data.data));
        history.push("/new-return/with-rtv/list", selectCustomer.npwp);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("error", error);
      showErrorDialog("Something went wrong!");
    }
  };

  const columnsCustomer = [
    { text: "No", dataField: "no" },
    { text: "Customer Code", dataField: "customerCode", align: "center" },
    { text: "Customer Name", dataField: "customerName" },
    {
      text: "Customer Block",
      dataField: "blockStatus",
      // formatter: StatusFormatter,
      align: "center",
    },
    { text: "Sales Division", dataField: "salesDivision", align: "center" },
    { text: "Dist Channel", dataField: "distChannel", align: "center" },
    { text: "Address", dataField: "street1" },
    { text: "City", dataField: "city" },
    { text: "Block Remarks", dataField: "blockRemark" },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="With Rtv"></CardHeader>
        <CardBody>
          {/* Filter */}
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      RTV Number <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setRtvNumber(e.target.value);
                      }}
                      value={rtvNumber}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      RTV Date <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <DatePicker
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      selected={rtvDate}
                      onChange={(date) => setRtvDate(date)}
                      isClearable
                      placeholderText="dd/mm/yyyy"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      RTV Receiving Date <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <DatePicker
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      selected={rtvReceivingDate}
                      onChange={(date) => setRtvReceivingDate(date)}
                      isClearable
                      placeholderText="dd/mm/yyyy"
                    />
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className={`${diffDays > 7 ? "" : "hide"} `}
                >
                  <Form.Label column sm={4}>
                    <b>Remarks 7-14 Days</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => {
                        setRemarkRtv(e.target.value);
                      }}
                      value={remarksRtv}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Customer Name <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.customerName}
                    />
                  </Col>
                  <Col sm={1}>
                    <Button variant="light" onClick={handleShow}>
                      <i className="fa fa-search"></i>
                    </Button>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="number"
                      disabled
                      value={selectCustomer.customerCode}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Division</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="number"
                      disabled
                      value={selectCustomer.salesDivision}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Distribution Channel</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="number"
                      disabled
                      value={selectCustomer.distChannel}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Plant</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="number"
                      disabled
                      value={selectCustomer.plantCode}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
          <Form>
            <Button className="btn btn-primary" onClick={handleSave}>
              save
            </Button>
          </Form>
        </CardBody>
      </Card>

      {/* customer */}

      <>
        <Modal show={show} onHide={handleClose} size="lg">
          <LoadingFetchData active={overlayStateCustomer} />
          <Modal.Header closeButton>
            <Modal.Title>Customer Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerCode(e.target.value);
                        }}
                        value={customerCode}
                        required
                        type="number"
                        placeholder="Costumer Code"
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerName(e.target.value);
                        }}
                        value={customerName}
                        required
                        type="text"
                        placeholder="Costumer Name"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchCustomer}
              >
                Search
              </Button>
            </Form>
            {showResultsCustomer && (
              <BootstrapTable
                remote
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="customerId"
                data={tableData}
                columns={columnsCustomer}
                pagination={paginationFactory(options)}
                onTableChange={handleTableChangeCustomer}
                rowEvents={rowEventsCustomer}
                hover
              />
            )}
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </>
    </>
  );
};
